import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76e85447")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.documentExecutionSchedulationsTableDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.snapshot')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "kn-button p-button-text p-button-rounded",
            onClick: _ctx.closeDialog
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("iframe", {
        id: "document-execution-snapshot-dialog-iframe",
        src: _ctx.url
      }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})